import apiClient from '../lib/apiClient';

/**
 * Service for Walk-in Hiring Drive Management
 */
const getDrives = async (filters = {}) => {
  try {
    const result = await apiClient.get('/walkin-drives', filters);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch walk-in drives' };
  }
};

const getDrive = async (id) => {
  try {
    const result = await apiClient.get(`/walkin-drives/${id}`);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch drive details' };
  }
};

const createDrive = async (driveData) => {
  try {
    const result = await apiClient.post('/walkin-drives', driveData);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to create walk-in drive' };
  }
};

const updateDrive = async (id, driveData) => {
  try {
    const result = await apiClient.put(`/walkin-drives/${id}`, driveData);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to update walk-in drive' };
  }
};

const deleteDrive = async (id) => {
  try {
    const result = await apiClient.delete(`/walkin-drives/${id}`);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to delete walk-in drive' };
  }
};

const getApplicants = async (driveId, filters = {}) => {
  try {
    const result = await apiClient.get(`/walkin-drives/${driveId}/applicants`, filters);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch applicants' };
  }
};

const getPanelQueue = async (driveId, panelNumber) => {
  try {
    const result = await apiClient.get(`/walkin-drives/${driveId}/panels/${panelNumber}`);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch panel queue' };
  }
};

const updateInterviewStatus = async (driveId, applicantId, data) => {
  try {
    const result = await apiClient.post(`/walkin-drives/${driveId}/applicants/${applicantId}/interview`, data);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to update interview evaluation' };
  }
};

const promoteApplicant = async (applicantId) => {
  try {
    const result = await apiClient.post(`/walkin-drives/applicants/${applicantId}/promote`, {});
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to promote applicant to ATS' };
  }
};

export default {
  getDrives,
  getDrive,
  createDrive,
  updateDrive,
  deleteDrive,
  getApplicants,
  getPanelQueue,
  updateInterviewStatus,
  promoteApplicant
};
